import { render } from "./perchase_body_main.vue?vue&type=template&id=5e4eaec6"
import script from "./perchase_body_main.vue?vue&type=script&lang=js"
export * from "./perchase_body_main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__